import React, { useContext, useState } from "react";
import { useQueryClient } from "react-query";
import { UserInfoContext } from "../../../WSUtils/UserInfoContext";
import { authAPI } from "../../../api/auth";
import { useLocStore } from "../../../wsLocalization";
import { LocContext } from "../../../wsLocalization/LocContext";
import { redirect } from "../../../WSUtils/urlUtils";

export const ConnectAccount = () => {
  const userInfo = useContext(UserInfoContext);
  const queryClient = useQueryClient();

  const L = useLocStore(LocContext.PROFILE);

  const [username, setUsername] = useState("andreas.modahl@websystemer.as");
  const [password, setPassword] = useState("testeren");
  const [connectAccountResponse, setConnectAccountResponse] = useState(null);

  return (
    <div>
      <form
        className="p-card p-component"
        onSubmit={async (event) => {
          event.preventDefault();
          const result = await authAPI.connectAccount({
            userInfo,
            password,
            username,
            concernId: userInfo.idConcern,
          });

          if (result.ok) {
            redirect("/profile", { userInfo, mergeQs: { connect: null } });
            queryClient.invalidateQueries();
          }
        }}
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          padding: "1rem 2rem 2rem 2rem",
        }}
      >
        <h4>
          {L.id("a26979914e6f").loc("Koble til eksisterende {firma} bruker")}
        </h4>
        <label>
          Username:
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
        </label>
        <label>
          Password:
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </label>

        <input type="submit" value="Submit" />
      </form>
      <pre
        style={{ whiteSpace: "pre-wrap", fontSize: 12, wordBreak: "break-all" }}
      >
        {JSON.stringify({ connectAccountResponse }, null, 2)}
      </pre>
    </div>
  );
};
